import { CountryDto } from "@cradua/data";
import { createReducer, on, Action } from "@ngrx/store";
import { EntityState, EntityAdapter, createEntityAdapter } from "@ngrx/entity";

import * as StakeholderReferenceActions from "./stakeholderreference.actions";

export const STAKEHOLDERREFERENCE_FEATURE_KEY = "stakeholderreference";

export interface StakeholderReferenceState extends EntityState<any> {
  selectedStakeholderReferenceId?: string | number; // which Country record has been selected
  loaded: boolean; // has the Country list been loaded
  error?: string | null; // last none error (if any)
}

export interface StakeholderReferenceGroupState extends EntityState<any> {
  selectedStakeholderReferenceGroupId?: string | number; // which Country record has been selected
  loaded: boolean; // has the Country list been loaded
  error?: string | null; // last none error (if any)
}

export interface StakeholderReferencePartialState {
  readonly [STAKEHOLDERREFERENCE_FEATURE_KEY]: StakeholderReferenceState;
}

export const stakeholderreferenceAdapter: EntityAdapter<any> =
  createEntityAdapter<
    any
  >({
    selectId: (stakeholderreference) => stakeholderreference.id,
    sortComparer: false,
  });

export const initialState: StakeholderReferenceState =
  stakeholderreferenceAdapter.getInitialState(
    {
      // set initial required properties
      loaded: false,
      error: null,
      selectedStakeholderReferenceId: null,
    },
  );

const stakeholderreferenceReducer = createReducer(
  initialState,
  on(StakeholderReferenceActions.loadStakeholderReference, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    StakeholderReferenceActions.loadStakeholderReferenceSuccess,
    (state, { stakeholderreference }) =>
      stakeholderreferenceAdapter.addAll(stakeholderreference, {
        ...state,
        loaded: false,
      }),
  ),
  on(
    StakeholderReferenceActions.loadStakeholderReferenceFailure,
    (state, { error }) => ({
      ...state,
      loaded: false,
      error,
    }),
  ),
  on(
    StakeholderReferenceActions.loadByTypeStakeholderReference,
    (state, inputtype) => ({
      ...state,
      loaded: true,
      error: null,
    }),
  ),
  on(
    StakeholderReferenceActions.loadByTypeStakeholderReferenceSuccess,
    (state, { stakeholderreference }) =>
      stakeholderreferenceAdapter.addAll(stakeholderreference, {
        ...state,
        loaded: false,
      }),
  ),
  on(
    StakeholderReferenceActions.loadByTypeStakeholderReferenceFailure,
    (state, { error }) => ({
      ...state,
      loaded: false,
      error,
    }),
  ),
  on(
    StakeholderReferenceActions.addStakeholderReference,
    (state, inputtype) => ({
      ...state,
      loaded: true,
      error: null,
    }),
  ),
  on(
    StakeholderReferenceActions.addStakeholderReferenceSuccess,
    (state, { newStakeholderReference }) =>
      stakeholderreferenceAdapter.addMany(newStakeholderReference, {
        ...state,
        loaded: false,
      }),
  ),
  on(
    StakeholderReferenceActions.addStakeholderReferenceFailure,
    (state, { error }) => ({
      ...state,
      loaded: false,
      error,
    }),
  ),
  on(
    StakeholderReferenceActions.updateStakeholderReference,
    (state, inputtype) => ({
      ...state,
      loaded: true,
      error: null,
    }),
  ),
  on(
    StakeholderReferenceActions.updateStakeholderReferenceSuccess,
    (state, { updateStakeholderReference }) =>
      stakeholderreferenceAdapter.upsertMany(updateStakeholderReference, {
        ...state,
        loaded: false,
      }),
  ),
  on(
    StakeholderReferenceActions.updateStakeholderReferenceFailure,
    (state, { error }) => ({
      ...state,
      loaded: false,
      error,
    }),
  ),
  on(
    StakeholderReferenceActions.removeStakeholderReference,
    (state, inputtype) => ({
      ...state,
      loaded: true,
      error: null,
    }),
  ),
  on(
    StakeholderReferenceActions.removeStakeholderReferenceSuccess,
    (state, { ids }) =>
      stakeholderreferenceAdapter.removeMany(ids, { ...state, loaded: false }),
  ),
  on(
    StakeholderReferenceActions.removeStakeholderReferenceFailure,
    (state, { error }) => ({
      ...state,
      loaded: false,
      error,
    }),
  ),
);

export function reducer(
  state: StakeholderReferenceState | undefined,
  action: Action,
) {
  return stakeholderreferenceReducer(state, action);
}
